import {
  AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS,
  AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_SUCCESS,
  AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_ERROR
} from './AgilePurchaseTradedProductsInstitutions.actions'

const initialState = {
  institutions: [],
  csvInstitutions: [],
  loading: false,
  error: null
}
/**
 * Agile Purchase Product's Institution's reducer.
 */
const agilePurchaseTradedProductsInstitutionsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS:
      return { ...state, loading: true }
    case AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_SUCCESS:
      return { ...state, ...payload, loading: false }
    case AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_ERROR:
      return { ...state, institutions: [], csvInstitutions: [], error: payload.error, loading: false }
    default:
      return state
  }
}

export default agilePurchaseTradedProductsInstitutionsReducer
